(() => {
  if (window.FlateriaSellingMarquee) return;
  window.FlateriaSellingMarquee = true;

  const selector = '[data-flateria-selling-marquee]';
  const pixelsPerSecond = 72;
  const observed = new WeakSet();

  function setDuration(marquee) {
    const group = marquee.querySelector('.flateria-selling-marquee__group');
    if (!group) return;

    const distance = group.getBoundingClientRect().width;
    if (distance > 0) {
      marquee.style.setProperty('--flateria-marquee-duration', `${distance / pixelsPerSecond}s`);
    }
  }

  function initialize(root = document) {
    root.querySelectorAll(selector).forEach((marquee) => {
      setDuration(marquee);
      if (observed.has(marquee)) return;

      observed.add(marquee);
      new ResizeObserver(() => setDuration(marquee)).observe(marquee);
    });
  }

  initialize();
  document.fonts?.ready.then(() => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
